module.exports = __webpack_public_path__ + "media/images/views/job_share/step-4-8075eebd8a13db2ef4224aa89bfaaf3d.png";